"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _equals = require("ramda/src/equals");

var _equals2 = _interopRequireDefault(_equals);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _helpersStylesIcons = require("./helpers-styles-icons");

var _RefundOptionCards = require("./RefundOptionCards");

var _RefundProgressView = require("./RefundProgressView");

var _RefundProgressView2 = _interopRequireDefault(_RefundProgressView);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NO_LEFTOVER_QUOTA = "NO_LEFTOVER_QUOTA";
var NO_LEFTOVER_PAID_QUOTA = "NO_LEFTOVER_PAID_QUOTA";
var REFUND_IN_PROGRESS = "REFUND_IN_PROGRESS";
var REFUND_ALREADY_INITIATED = "REFUND_ALREADY_INITIATED";

function PointsRedemptionView(_ref) {
  var eolConfig = _ref.eolConfig,
      eligibilityData = _ref.eligibilityData,
      dialogs = _ref.dialogs;

  if (!eolConfig || !eligibilityData) {
    return null;
  }

  var totalPoints = eligibilityData.totalPoints,
      unredeemablePoints = eligibilityData.unredeemablePoints,
      pointsToRefund = eligibilityData.pointsToRefund;


  return _react2.default.createElement(
    "div",
    { className: _helpersStylesIcons.page },
    _react2.default.createElement(
      "h2",
      { className: _helpersStylesIcons.title },
      "Convert your Quixel points"
    ),
    _react2.default.createElement(
      "section",
      { className: _helpersStylesIcons.pointsSummary },
      _react2.default.createElement(
        "h4",
        { className: _helpersStylesIcons.pointsSummaryTitle },
        "Your Points"
      ),
      _react2.default.createElement(
        "div",
        { className: _helpersStylesIcons.pointsSummaries },
        _react2.default.createElement(
          "div",
          { className: _helpersStylesIcons.pointsSummaryItem },
          _react2.default.createElement(
            "span",
            null,
            "Total points:"
          ),
          _react2.default.createElement(
            "span",
            null,
            totalPoints,
            " points"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: _helpersStylesIcons.pointsSummaryItem },
          _react2.default.createElement(
            "span",
            null,
            "Free points:"
          ),
          _react2.default.createElement(
            "span",
            null,
            unredeemablePoints,
            " points",
            " ",
            _react2.default.createElement(
              "span",
              { className: (0, _helpersStylesIcons.textStyles)({ color: _helpersStylesIcons.gray, style: "italic" }) },
              "(free points are not eligible for conversion or refund)"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: _helpersStylesIcons.pointsSummaryItem },
          _react2.default.createElement(
            "span",
            null,
            "Convertible points:"
          ),
          _react2.default.createElement(
            "span",
            null,
            pointsToRefund,
            " points"
          )
        )
      )
    ),
    _react2.default.createElement(
      "section",
      {
        className: (0, _helpersStylesIcons.classes)((0, _helpersStylesIcons.boxStyles)({ margin: "24px auto" }), (0, _helpersStylesIcons.textStyles)({ size: "16px", height: "24px" })) },
      _react2.default.createElement(
        "p",
        null,
        "Quixel has discontinued its point system. If you accrued points through paid subscriptions over the years, those points are eligible for conversion or refund. Any points that you accrued for free are not eligible for conversion or refund. Your points balance is shown above."
      ),
      _react2.default.createElement("br", null),
      _react2.default.createElement(
        "p",
        null,
        "The deadline to convert or request a refund for your eligible points is",
        " ",
        (0, _helpersStylesIcons.getFormattedDate)(eolConfig.common.cutOffDate),
        ". After that date, your points balance will be zeroed out and you will no longer be able to convert or request a refund for any previous balance."
      ),
      _react2.default.createElement("br", null),
      _react2.default.createElement(
        "p",
        null,
        "Please select what you would like to do with your eligible points balance. Once you have selected one of the options below, your selection cannot be changed."
      ),
      _react2.default.createElement("br", null)
    ),
    _react2.default.createElement(
      "section",
      { className: (0, _helpersStylesIcons.boxStyles)({ display: "flex", gap: "32px", flexWrap: "wrap" }) },
      _react2.default.createElement(_RefundOptionCards.EpicWalletOptionCard, { dialogs: dialogs, eligibilityData: eligibilityData }),
      _react2.default.createElement(_RefundOptionCards.HyperWalletOptionCard, { dialogs: dialogs, eligibilityData: eligibilityData })
    ),
    _react2.default.createElement(
      "div",
      { className: (0, _helpersStylesIcons.boxStyles)({ marginTop: 40 }) },
      "If you need help, please contact",
      " ",
      _react2.default.createElement(
        "a",
        { href: _config2.default.forumBaseUrl, className: _helpersStylesIcons.anchorStyles, target: "_blank" },
        "our support team"
      ),
      "."
    )
  );
}

var PointsRedemptionController = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(PointsRedemptionController, _React$Component);

  function PointsRedemptionController(props) {
    (0, _classCallCheck3.default)(this, PointsRedemptionController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PointsRedemptionController.__proto__ || (0, _getPrototypeOf2.default)(PointsRedemptionController)).call(this, props));

    _this.state = {
      showRefundProgress: false
    };
    return _this;
  }

  (0, _createClass3.default)(PointsRedemptionController, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!(0, _equals2.default)(prevProps.refundEligibility, this.props.refundEligibility)) {
        var _props$refundEligibil = this.props.refundEligibility,
            isLoading = _props$refundEligibil.isLoading,
            data = _props$refundEligibil.data,
            error = _props$refundEligibil.error;


        if (!isLoading) {
          if (data && (!data.isEligible || data.code === NO_LEFTOVER_QUOTA || data.code === NO_LEFTOVER_PAID_QUOTA)) {
            this.props.router.push("/");
            return;
          }

          if (error && (error.code === REFUND_IN_PROGRESS || error.code === REFUND_ALREADY_INITIATED)) {
            this.setState({ showRefundProgress: true });
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          refundEligibility = _props.refundEligibility,
          eolConfig = _props.eolConfig;
      var isLoading = refundEligibility.isLoading,
          data = refundEligibility.data;


      if (isLoading) {
        return _react2.default.createElement(
          "div",
          { className: _helpersStylesIcons.spinnerStyles },
          _react2.default.createElement(_Preloader2.default, null)
        );
      }

      if (this.state.showRefundProgress) {
        return _react2.default.createElement(_RefundProgressView2.default, { dialogs: this.context.dialogs });
      }

      // If user is not eligible for any type of refund, return `null` to avoid unhandled rejection errors.
      if (data && !data.isEligible) {
        return null;
      }

      return _react2.default.createElement(PointsRedemptionView, {
        eolConfig: eolConfig,
        eligibilityData: data,
        dialogs: this.context.dialogs
      });
    }
  }]);
  return PointsRedemptionController;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    eolConfig: state.eol.eolConfig,
    refundEligibility: state.user.refundEligibility
  };
})(PointsRedemptionController);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ConvertPoints/ConvertPoints.jsx
// module id = 2908
// module chunks = 0